<template>
  <div v-if="content.cosTodolist">
    <div class="report-title">
      <p>
        <i class="iconfont icon-street-view"></i>
        在自我管理上
      </p>
    </div>
    <div class="report-area">
      <p class="type-name">自我认知</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.自我认知"></p>
    </div>
    <div class="report-area">
      <p class="type-name">生活管理</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.生活管理"></p>
    </div>
    <div class="report-title">
      <p>
        <i class="iconfont icon-book"></i>
        在教育&职业探索上
      </p>
    </div>
    <div class="report-area">
      <p class="type-name">职业认知</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.职业认知"></p>
    </div>
    <div class="report-area">
      <p class="type-name">人际询问</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.人际询问"></p>
    </div>
    <div class="report-area">
      <p class="type-name">工作机会探索</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.工作机会探索"></p>
    </div>
    <div class="report-title">
      <p>
        <i class="iconfont icon-download"></i>在决策&规划上
      </p>
    </div>
    <div class="report-area">
      <p class="type-name">生涯决策</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.生涯决策"></p>
    </div>
    <div class="report-area">
      <p class="type-name">生涯规划</p>
      <p v-html="content.cosTodolist.mapSecondDimDesc.生涯规划"></p>
    </div>
  </div>
</template>

<script>
 export default {
  name: 'ReportDevelop',
  props: {
    content:Object
  }
 }

</script>

<style lang="stylus" scoped>
.report-title
  background-color:#fdc740
</style>
